import React, { useContext, useMemo } from 'react';

import StickyPageHeader from '../components/common/StickyPageHeader';
import TerminalsServicedList from '../components/lists/TerminalsServicedList';
import { AuthContext } from '../contexts/authContext';
import { useSelectedCarrier } from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierTerminalsPage = ({ disableLayout, routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const carrierTerminals = useMemo(
    () => selectedCarrier?.terminals || [],
    [selectedCarrier?.terminals]
  );

  const canView = !!selectedCarrier;

  const content =
    canView && (
      <>
        <StickyPageHeader
          subtitle={selectedCarrier.name}
          title="Terminals Serviced"
        />
        <TerminalsServicedList id="terminals" terminals={carrierTerminals} />
      </>
    );

  if (disableLayout) {
    return content || null;
  }

  return (
    <Layout
      carrierLoading={!selectedCarrier}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {content}
    </Layout>
  );
};

export default CarrierTerminalsPage;
